import type { HTMLAttributes } from "react";
import { cx } from "./cx";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** The card signature (elevation.frame): mint inset hairline + soft float, radius.xl. */
  framed?: boolean;
}

/** Surface container — `framed` is the hero-card treatment (upload card, map frame). */
export function Card({ framed = false, className, children, ...rest }: CardProps) {
  return (
    <div className={cx("pz-card", framed && "pz-card--framed", className)} {...rest}>
      {children}
    </div>
  );
}

export function CardHeader({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cx("pz-card__header", className)} {...rest} />;
}

export function CardTitle({ className, ...rest }: HTMLAttributes<HTMLHeadingElement>) {
  return <h3 className={cx("pz-card__title", className)} {...rest} />;
}

export function CardBody({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cx("pz-card__body", className)} {...rest} />;
}

export function CardFooter({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cx("pz-card__footer", className)} {...rest} />;
}
